enum ActionTypes {
  REMOVE_ALL_SELECTED_PRODUCTS="REMOVE_ALL_SELECTED_PRODUCTS",
  REMOVE_ALL_INTERFEROMETRIC_STACKS="REMOVE_ALL_INTERFEROMETRIC_STACKS",
  SEARCH_STARTED= "SEARCH_STARTED",
  SEARCH_RESULTS_SUCCESS= "SEARCH_RESULTS_SUCCESS",
  SEARCH_RESULTS_ERROR= "SEARCH_RESULTS_ERROR",
  TOGGLE_PRODUCTS_VIEW= "TOGGLE_PRODUCTS_VIEW",
  TOGGLE_FRAMING_VIEW= "TOGGLE_FRAMING_VIEW",
  UPDATE_SELECTED_PRODUCTS= "UPDATE_SELECTED_PRODUCTS",
  UPDATE_IS_INTERFEROMETRIC_STACK_SEARCH="UPDATE_IS_INTERFEROMETRIC_STACK_SEARCH",
  RESET_SEARCH = "RESET_SEARCH"
}
export default ActionTypes;


export const PRODUCTS_MAP = [
  {
    tab_name: "Satellite Imagery",
    code: "MAPIT_CATEGORY_001",
    products: [
      {
        name: "Radar",
        mission_type: "Radar",
        code: "MAPIT_PRODUCT_001"
      },
    ]
  }
]
